module.exports = __webpack_public_path__ + "assets/img/tx12g_2.6acbd5eb.jpg";